module.exports = "/_next/static/images/being-verified-8a2e1ff6ec76bfff3f28127451d2253f.svg";